import styled from 'styled-components';

export const ChartContainer = styled.div`
  width: 100%;
  max-width: 1500px;
  margin: 2rem auto;
  padding: 1rem;
  background-color: #f7f9fc;
  border-radius: 10px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  overflow-x: auto;

  @media (max-width: 767px) {
    margin: 1rem 0;
    padding: 0.75rem;
  }
`;

export const ChartsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 2rem;
  flex-wrap: wrap;

  @media (max-width: 991px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;

export const ChartWrapper = styled.div`
  flex: 1;
  min-width: 280px;
  width: 100%;
  max-width: 100%;
  position: relative;

  canvas {
    max-width: 100% !important;
    height: auto !important;
  }
`;
